export const tenantSettings = [{ key: 'tenant72_api', name: 'riyad', theme: 'riyadConfig' },];

export const defaultTenantKey = tenantSettings[0];
